export function applyIosCaretNotAppearingOnTapFix(element) {
    element.style.webkitUserSelect = "auto";
}
